export type ViewSettingsUIState = null | {
  type: ViewSettingsUIStateItem
  payload?: any
}

export enum ViewSettingsUIStateItem {
  GENERAL,
  COLUMN,
}
